import { StencilCDNImage } from '@/components/Common/StencilImage'

export function StrapiV4TrustWidget({
  theme,
  classNames,
}: {
  theme?: { bg: string; text: string }
  classNames?: string
}) {
  return (
    <div
      className={`${theme?.text ? theme.text : 'text-brand-black'} ${
        theme?.bg ? theme.bg : 'bg-brand-white'
      } ${
        classNames ? classNames : ''
      } flex flex-col items-center justify-center`}
    >
      <StencilCDNImage
        src="https://indcdn.indmoney.com/public/images/trust_image.png"
        width={215}
        height={50}
      />
      <h3 className="mt-5 text-center text-5xl font-semibold lg:px-32 lg:text-[78px] lg:leading-[88px]">
        Trusted by 10 million+ happy investors
      </h3>
      <p
        className={`${
          theme?.text ? theme.text : 'text-brand-grey-dark'
        } mt-5 px-10 text-center text-2xl font-medium leading-9 lg:px-56`}
      >
        Open your account in a minute. Invest in Indian Stocks, US Stocks,
        Mutual Funds, ETFs, Fixed Deposit and NPS.
      </p>
    </div>
  )
}
